<template>
  <div>
    <label class="text-sm font-medium text-gray-500">{{ $t('contact.phone_numbers') }}</label>
    <div class="flex space-x-2 group">
      <p class="flex-1 text-gray-900 mt2 truncate">
        {{ concatenatedPhoneNumbers || $t('global.not_set') }}
      </p>

      <div class="hidden flex-none group-hover:block">
        <PhoneNumbersPropertyEditModal :contact-id="contactId" />
      </div>
    </div>
  </div>
</template>

<script>
import PhoneNumbersPropertyEditModal from './phoneNumbersProperty/PhoneNumbersPropertyEditAction.vue';

export default {
  components: {
    PhoneNumbersPropertyEditModal,
  },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  computed: {
    contact() {
      return this.$store.state.entities.contacts.byId[this.contactId];
    },
    concatenatedPhoneNumbers() {
      return (this.contact?.phoneNumbers || [])
        .map((phoneNumberId) => this.$store.state.entities.phoneNumbers.byId[phoneNumberId])
        .filter(Boolean)
        .map((phoneNumber) => phoneNumber.number)
        .join(', ');
    },
  },
};
</script>
